module.exports = __webpack_public_path__ + "img/Frame 795three.0644464d.png";